module.exports = ".top-images{\r\n    height: 350px;\r\n}"